export default __webpack_public_path__ + "static/media/header-challenge-icon.8f6dc4ed.svg";